import Api from '@/services/Api'
import ApiDownloadReporte from '@/services/Api'

const HEADERURL = 'compras/req_compra/';
const ACTION_PARA_COTIZAR = 'para_cotizar';
const ACTION_ADD_DETAIL = 'agregar_detalle';
const ACTION_DELETE_DETAIL = 'eliminar_detalle';
const ACCION_MODIFICAR_DETALLE = 'modificar_detalle';
const ACTION_GENERAR_COTIZACION = 'generar_cotizacion';
const ACTION_CERRAR = 'cerrar';
const ACTION_ANULAR = 'anular';
const ACTION_ABRIR = 'abrir';
const ACTION_REPORTE_PDF = 'pdf';
export default {

    fetch(params) {

        return Api().get(HEADERURL, {

            params: params

        });

    },

    getById(id) {

        return Api().get(`${HEADERURL}${id}`);

    },

    save(params) {
        if (params.id != null) {
            return Api().put(`${HEADERURL}${params.id}` + '/', params);
        }
        return Api().post(HEADERURL, params);

    },

    para_cotizar(params){
        return Api().get(`${HEADERURL}${ACTION_PARA_COTIZAR}/`, params);
    },

    addDetail(id, params) {
        return Api().post(`${HEADERURL}${id}/${ACTION_ADD_DETAIL}/`, params);

    },
    editarDetalle(id, params) {

        return Api().post(`${HEADERURL}${id}/${ACCION_MODIFICAR_DETALLE}/`, params);

    },

    deleteDetail(id, params) {

        return Api().post(`${HEADERURL}${id}/${ACTION_DELETE_DETAIL}/`, params);

    },

    abrir(id) {

        return Api().post(`${HEADERURL}${id}/${ACTION_ABRIR}/`);

    },

    cerrar(id) {

        return Api().post(`${HEADERURL}${id}/${ACTION_CERRAR}/`);

    },

    anular(id) {

        return Api().post(`${HEADERURL}${id}/${ACTION_ANULAR}/`);

    },

    pdf(id, params) {

        return Api().post(`${HEADERURL}${id}/${ACTION_REPORTE_PDF}/`, params);

    },

    generar_cotizacion(id) {

        return Api().post(`${HEADERURL}${id}/${ACTION_GENERAR_COTIZACION}/`);

    },


}